import {
  CaretDown,
  CarProfile,
  FolderUser,
  GraduationCap,
  ReadCvLogo,
} from '@phosphor-icons/react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion'
import { Prices } from '@/blocks/Packets/Component'

const MobileCosts = ({
  locationName,
  prices,
}: {
  locationName: string
  prices: Prices
}) => {
  return (
    <Accordion type="single" collapsible className="mx-5 mt-6 lg:hidden">
      <AccordionItem value="insurance" className="border-b border-gray-150">
        <AccordionTrigger className="group flex w-full cursor-pointer items-center justify-between space-x-6 py-4">
          <div className="flex min-w-0 items-center">
            <FolderUser
              size={24}
              weight="bold"
              className="shrink-0 text-gray-600"
            />
            <span className="ml-3 truncate text-left font-bold text-wrap md:text-xl">
              Admin- & Versicherungspauschale
            </span>
          </div>
          <div className="flex items-center">
            <p className="whitespace-nowrap">90 CHF</p>
            <CaretDown
              size={20}
              weight="bold"
              className="ml-3 shrink-0 transition duration-150 group-data-[state=open]:rotate-180"
            />
          </div>
        </AccordionTrigger>
        <AccordionContent className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
          <p className="pb-4 text-gray-800">
            Ab der zweiten Fahrlektion verrechnen wir dir einmalig eine{' '}
            Versicherungs- und Adminpauschale für deine gesamte Fahrausbildung.
            Diese Pauschale deckt alle administrativen Kosten sowie deinen
            Anteil an der Vollkaskoversicherung. Sie schützt dich umfassend bei
            Schäden am Fahrschulauto, ohne dass für dich ein Selbstbehalt
            anfällt.
          </p>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="single_lesson" className="border-b border-gray-150">
        <AccordionTrigger className="group flex w-full cursor-pointer items-center justify-between space-x-6 py-4">
          <div className="flex min-w-0 items-center">
            <CarProfile
              size={24}
              weight="bold"
              className="shrink-0 text-gray-600"
            />
            <span className="ml-3 truncate text-left font-bold text-wrap md:text-xl">
              Einzellektion (45 min)
            </span>
          </div>
          <div className="flex items-center">
            <p className="whitespace-nowrap">{prices.lesson_price} CHF</p>
            <CaretDown
              size={20}
              weight="bold"
              className="ml-3 shrink-0 transition duration-150 group-data-[state=open]:rotate-180"
            />
          </div>
        </AccordionTrigger>
        <AccordionContent className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
          <p className="pb-4 text-gray-800">
            Eine Fahrlektion in Zürich dauert standardmässig 45 Minuten und
            kostet {prices.lesson_price} CHF. Natürlich sind aber auch Lektionen
            à 60 Minuten ({prices.lesson_60_price} CHF), 75 Minuten (
            {prices.lesson_75_price}
            CHF) oder 90 Minuten ({prices.lesson_90_price} CHF) möglich. Du
            entscheidest, wie lange deine Lektionen dauern und kannst sie direkt
            online buchen.
          </p>
        </AccordionContent>
      </AccordionItem>
      {prices.vku_price && (
        <AccordionItem value="vku" className="border-b border-gray-150">
          <AccordionTrigger className="group flex w-full cursor-pointer items-center justify-between space-x-6 py-4">
            <div className="flex min-w-0 items-center">
              <ReadCvLogo
                size={24}
                weight="bold"
                className="shrink-0 text-gray-600"
              />
              <span className="ml-3 truncate text-left font-bold text-wrap md:text-xl">
                VKU Kurs
              </span>
            </div>
            <div className="flex items-center">
              <p>{prices.vku_price} CHF</p>
              <CaretDown
                size={20}
                weight="bold"
                className="ml-3 shrink-0 transition duration-150 group-data-[state=open]:rotate-180"
              />
            </div>
          </AccordionTrigger>
          <AccordionContent className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
            <p className="pb-4 text-gray-800">
              Der Verkehrskundeunterricht (VKU) in {locationName} ist
              obligatorisch und ein wichtiger Teil deiner Fahrausbildung. Der
              Kurs vermittelt dir das grundlegende Verständnis für Sicherheit im
              Strassenverkehr. In kleinen Gruppen lernst du, Situationen richtig
              einzuschätzen, mögliche Gefahren schon im Vorfeld zu erkennen und
              entsprechend zu reagieren.
            </p>
          </AccordionContent>
        </AccordionItem>
      )}
      {prices.exam_price_range && (
        <AccordionItem value="exam_fee" className="border-b border-gray-150">
          <AccordionTrigger className="group flex w-full cursor-pointer items-center justify-between space-x-6 py-4">
            <div className="flex min-w-0 items-center">
              <GraduationCap
                size={24}
                weight="bold"
                className="shrink-0 text-gray-600"
              />
              <span className="ml-3 truncate text-left font-bold text-wrap md:text-xl">
                Prüfung
              </span>
            </div>
            <div className="flex items-center">
              <p>{examPriceRange(prices.exam_price_range)} CHF</p>
              <CaretDown
                size={20}
                weight="bold"
                className="ml-3 shrink-0 transition duration-150 group-data-[state=open]:rotate-180"
              />
            </div>
          </AccordionTrigger>
          <AccordionContent className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
            <p className="pb-4 text-gray-800">
              Für die praktische Prüfung inkl. Einfahren wird eine{' '}
              Prüfungspauschale verrechnet. Sie beinhaltet Einfahren (ca. 45
              Minuten), Vorbereitung, Prüfung, Abschlussgespräch und Rückfahrt.
              Die Kosten seitens Strassenverkehrsamt (STVA) sind nicht in dieser
              Pauschale enthalten und werden dir vom STVA nach der Prüfung
              separat in Rechnung gestellt.
            </p>
          </AccordionContent>
        </AccordionItem>
      )}
    </Accordion>
  )
}

const DesktopCosts = ({
  locationName,
  prices,
}: {
  locationName: string
  prices: Prices
}) => {
  return (
    <div className="mx-6 mt-5 hidden grid-cols-2 gap-x-24 lg:grid">
      <div className="border-b border-gray-150 py-6">
        <div className="flex items-center justify-between space-x-8">
          <div className="flex items-center space-x-4">
            <div className="flex size-12 items-center justify-center rounded-full border border-gray-100 bg-gray-50">
              <FolderUser size={24} weight="bold" className="text-gray-600" />
            </div>
            <p className="text-lg font-bold">Admin- & Versicherungspauschale</p>
          </div>
          <p className="text-lg">90 CHF</p>
        </div>
        <p className="mt-4 text-gray-800">
          Ab der zweiten Fahrlektion verrechnen wir dir einmalig eine{' '}
          Versicherungs- und Adminpauschale für deine gesamte Fahrausbildung.
          Diese Pauschale deckt alle administrativen Kosten sowie deinen Anteil
          an der Vollkaskoversicherung. Sie schützt dich umfassend bei Schäden
          am Fahrschulauto, ohne dass für dich ein Selbstbehalt anfällt.
        </p>
      </div>
      <div className="border-b border-gray-150 py-6">
        <div className="flex items-center justify-between space-x-8">
          <div className="flex items-center space-x-4">
            <div className="flex size-12 items-center justify-center rounded-full border border-gray-100 bg-gray-50">
              <CarProfile size={24} weight="bold" className="text-gray-600" />
            </div>
            <p className="text-lg font-bold">Einzellektion (45 min)</p>
          </div>
          <p className="text-lg">{prices.lesson_price} CHF</p>
        </div>
        <p className="mt-4 text-gray-800">
          Eine Fahrlektion in Zürich dauert standardmässig 45 Minuten und kostet{' '}
          {prices.lesson_price} CHF. Natürlich sind aber auch Lektionen à 60
          Minuten ({prices.lesson_60_price} CHF), 75 Minuten (
          {prices.lesson_75_price}
          CHF) oder 90 Minuten ({prices.lesson_90_price} CHF) möglich. Du
          entscheidest, wie lange deine Lektionen dauern und kannst sie direkt
          online buchen.
        </p>
      </div>
      {prices.vku_price && (
        <div className="border-b border-gray-150 py-6">
          <div className="flex items-center justify-between space-x-8">
            <div className="flex items-center space-x-4">
              <div className="flex size-12 items-center justify-center rounded-full border border-gray-100 bg-gray-50">
                <ReadCvLogo size={24} weight="bold" className="text-gray-600" />
              </div>
              <p className="text-lg font-bold">VKU Kurs</p>
            </div>
            <p className="text-lg">{prices.vku_price} CHF</p>
          </div>
          <p className="mt-4 text-gray-800">
            Der Verkehrskundeunterricht (VKU) in {locationName} ist
            obligatorisch und ein wichtiger Teil deiner Fahrausbildung. Der Kurs
            vermittelt dir das grundlegende Verständnis für Sicherheit im
            Strassenverkehr. In kleinen Gruppen lernst du, Situationen richtig
            einzuschätzen, mögliche Gefahren schon im Vorfeld zu erkennen und
            entsprechend zu reagieren.
          </p>
        </div>
      )}
      {prices.exam_price_range && (
        <div className="border-b border-gray-150 py-6">
          <div className="flex items-center justify-between space-x-8">
            <div className="flex items-center space-x-4">
              <div className="flex size-12 items-center justify-center rounded-full border border-gray-100 bg-gray-50">
                <GraduationCap
                  size={24}
                  weight="bold"
                  className="text-gray-600"
                />
              </div>
              <p className="text-lg font-bold">Prüfung</p>
            </div>
            <p className="text-lg">
              {examPriceRange(prices.exam_price_range)} CHF
            </p>
          </div>
          <p className="mt-4 text-gray-800">
            Für die praktische Prüfung inkl. Einfahren wird eine{' '}
            Prüfungspauschale verrechnet. Sie beinhaltet Einfahren (ca. 45
            Minuten), Vorbereitung, Prüfung, Abschlussgespräch und Rückfahrt.
            Die Kosten seitens Strassenverkehrsamt (STVA) sind nicht in dieser
            Pauschale enthalten und werden dir vom STVA nach der Prüfung separat
            in Rechnung gestellt.
          </p>
        </div>
      )}
    </div>
  )
}

const examPriceRange = ({ min, max }: { min: number; max: number }) => {
  if (min === max) {
    return `${min}`
  }
  return `${min}–${max}`
}

export { MobileCosts, DesktopCosts }
